import React, { useEffect, useState } from "react";
import SlidingButton from "./SlidingButton";
import { Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ToggleSwitch from "./ToggleSwitch";
import { FaCheckCircle } from "react-icons/fa";
import { FaRegCheckCircle } from "react-icons/fa";

const useStyles = makeStyles({
    root: {
        borderRadius: 10,
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        "& p": {
            background: "white",
            width: "-moz-fit-content",
            width: "fit-content",
            padding: "2px 8px",
            font: "normal normal normal 14px/21px Poppins",
            letterSpacing: "0px",
            color: "#505050",
        },
        "& .MuiTabs-root": {
            minHeight: "32px",
        },
        "& .MuiTabs-indicator": {
            height: 32,
            minHeight: 32,
        },
        "& .MuiButtonBase-root": {
            height: 32,
            minHeight: 32,
            minWidth: "auto",
            width: "52px",
        },
    },
});

function Connectivity(props) {
    const { onChange, value, options } = props;
    const classes = useStyles();
    const [option_values, setOption] = useState([
        { key: "wifi", value: "Wifi" },
        { key: "sim", value: "SIM" },
    ]);

    useEffect(() => {
        if (options !== "" && options !== null) {
            const arr = options.split(",");
            const result = arr.map((item) => ({
                key: item,
                value: item.toUpperCase(),
            }));
            setOption(result);
        }
    }, options);

    // Check if we should show the PinPadInput-like component
    const shouldShowVlWirelessInput = option_values.some(option => option.key === 'vl_wireless');

    const isChecked = value === 'vl_wireless';

    return (
        <Stack class={classes.root}>
            <Typography class="title">Connectivity?</Typography>
            {shouldShowVlWirelessInput ? (
                <div className={classes.root}>
                    <div className="input-wrapper">
                        <label for="first">Connectivity</label>
                        <input
                            type="text"
                            value="VL Wireless"
                            name="connectivity_default"
                            placeholder="VL Wireless"
                            readOnly
                        />
                        {isChecked ? (
                            <FaCheckCircle
                                className="type-check type-checked pointer"
                                onClick={(e) => {
                                    onChange("connectivity_default", '');
                                }}
                            />
                        ) : (
                            <FaRegCheckCircle
                                className="type-check type-unchecked"
                                type="button"
                                onClick={(e) => {
                                    onChange("connectivity_default", 'vl_wireless');
                                }}
                            />
                        )}
                    </div>
                </div>
            ) : (
                <ToggleSwitch
                    handleChange={(_e, v) => onChange("connectivity_default", v)}
                    value={value}
                    options={option_values}
                />
            )}
        </Stack>
    );
}

export default Connectivity;
